export const GROWTH_MAP_COPIES = {
  assignLineName: 'Asigna un nombre a la línea comportamental',
  behavioralLineInfoDescription:
    'Un título que agrupa comportamientos asociados a un mismo conocimiento o habilidad. Hace referencia a cómo ese conocimiento se puede evidenciar en distintos niveles (trainee, junior, advanced, senior, etc.), conectándolos bajo la misma temática.',
  behavioralLineInfoTitle: '¿Qué es una línea comportamental?',
  currentSeniorityTag: 'Seniority actual',
  closeButtonLabel: 'Cerrar',
  mapBadge: 'Mapa',
  goToSkillset: 'Ir a Skillset by Pragma',
  configureWeights: 'Configurar pesos',
  configureGrades: 'Configurar calificación',
  editDateWarning:
    'No puedes modificar esta versión porque faltan menos de {days} días para su publicación.',
  behavioralLineDefault: 'Línea Comportamental {position}',
  behavioralLineTitle: 'Línea Comportamental',
  addBehaviorAriaLabel: 'Agregar comportamiento',
  addBehaviorIconAlt: 'Agregar comportamiento',
  configureBehavioralLineAriaLabel: 'Configurar línea comportamental',
  editBehavioralLineIconAlt: 'Editar',
  deleteBehavioralLineAriaLabel: 'Eliminar línea comportamental',
  deleteBehavioralLineIconAlt: 'Eliminar',
  resourceLinkAlt: 'resource-link',
  historialIconAlt: 'historial-icon',
  arrowIconAlt: 'arrow-icon',
  viewGeneralWeights: 'Ver pesos generales',
  descriptionTitle: 'Descripción',
  cancelButtonLabel: 'Cancelar',
  saveButtonLabel: 'Guardar',
  behavioralLineSearchText:
    'Puedes buscar o añadir un nombre para la línea comportamental asociada a estos comportamientos:',
  behavioralLineSearchTextNoSelector:
    'Agrega un nombre para la línea comportamental asociada a estos comportamientos:',
  selectExistingLineTitle: 'Selecciona una línea comportamental existente',
  selectExistingLineSubtitle:
    'Estas son las líneas comportamentales que otros chapters ya han asociado a estos comportamientos:',
  selectLineRadioPlaceholder: 'Selecciona una línea',
  orPreferText: 'O, si prefieres:',
  inputPlaceholder: 'Escribe un nombre',
  infoIconAlt: 'info',
  createNewDraft: 'Crear Nuevo Borrador',
  savePublishedChanges: 'Guardar Cambios',
  publishedMapSaveSuccess: 'Cambios guardados exitosamente',
  publishedMapSaveSuccessDescription:
    'Los cambios se han aplicado directamente al mapa publicado y ya están visibles.',
  publishedMapRestrictionTitle: 'Acción no permitida',
  publishedMapRestrictionDescription:
    'Esta acción requiere crear un nuevo borrador. No es posible modificar la estructura de un mapa publicado.',
  toolbar: {
    chapterPrefix: 'Chapter',
    draftListTitle: 'Listado Borradores',
    historicListTitle: 'Listado histórico de mapas',
    updateVersion: 'Actualizar Versión',
    saveDraft: 'Guardar borrador',
    publishVersion: 'Publicar Versión',
    editUntilMessage:
      'Podrás hacer modificaciones hasta el {date} ({days} días antes de la fecha de publicación).',
    scheduledPublicationMessage: 'Publicación programada para el {date}.',
    editLimitMessage: 'Podrás hacer modificaciones hasta el {date}.',
  },
  configureWeightsModal: {
    title: 'Pesos de los comportamientos por seniority',
    subTitle: 'Configura la calificación de la valoración',
    headerTitle: 'Mapa de Crecimiento',
    errorCalculationType: 'Error al guardar el tipo de cálculo',
    errorSeniorityThresholds: 'Error al guardar los umbrales de seniority',
    errorSectionLevels: 'Error al guardar la cantidad de niveles',
    instruction:
      'Establece la importancia de cada comportamiento y asigna un peso a cada uno, el valor más alto indica mayor importancia.',
    instructionTwo:
      'Define la importancia de cada comportamiento en este seniority.Un peso más alto indica mayor relevancia en la valoración final del pragmático.',
    selectSeniorityTitlte:
      'Selecciona un seniority para configurar los pesos de sus comportamientos:',
    finalize: 'Finalizar configuración',
    saveChanges: 'Guardar',
    cancel: 'Cancelar',
    total: 'Total pesos para el seniority',
    totalExplanation: 'Muestra la suma total de los pesos configurados para este seniority.',
    technical: 'Technical',
    team: 'Team',
    behaviorName: 'Nombre del comportamiento',
    weight: 'Peso',
    weightExplanation:
      'valor numérico que define su relevancia. A mayor peso, mayor impacto en la calificación.',
    invalidWeight: 'Este valor debe ser mayor a cero',
    currentWeight: 'Peso actual',
    calculationType: {
      title: 'Tipo de cálculo',
      description:
        'Define cómo se calculará la valoración de este mapa. Selecciona el método que determina cómo se comparan los comportamientos entre sí para generar la calificación final.',
      vertical: 'vertical',
      horizontal: 'horizontal',
      verticalOption: 'Valoración vertical',
      horizontalOption: 'Valoración horizontal',
      radioValue: 'typeCalculation',
      radioGroupName: 'radioGroupCalculationType',
      verticalOptionDescription:
        'Valoración vertical: Compara comportamientos dentro del mismo seniority. Úsalo cuando la progresión interna por nivel es lo más relevante.',
    },
    autoValorationType: {
      title: 'Autovaloración para el pragmático',
      description:
        'Define si el pragmático podrá autovalorarse como parte del proceso. Esta opción promueve reflexión y conversaciones más alineadas entre manager y pragmático.',
      withAutoValoration: 'Con autovaloración',
      withoutAutoValoration: 'Sin autovaloración',
      withAutoValorationDescription: 'El pragmático podrá puntuar sus propios comportamientos.',
    },
    reachSeniority: {
      title: 'Puntos para alcanzar el seniority',
      description:
        'Establece los puntos necesarios para que un pragmático alcance cada seniority en este mapa.',
      points: 'Puntos',
      pointsExplanation:
        'Número total de puntos requeridos para que el pragmático alcance este seniority.',
      suggestedPoints: 'Puntos sugeridos',
      suggestedPointsExplanation:
        'Recomendación basada en la configuración del sistema. Puedes ajustarlo según tu necesidad.',
    },
    sectionLevels: {
      title: 'Niveles por sección',
      description:
        'Define la cantidad de niveles que tendrá cada sección (seniority) de este mapa.',
      quantityOfLevels: 'Niveles',
      withinSeniority: 'Dentro del seniority',
      levelsExplanation:
        'Define en cuántos niveles (L1, L2, L3...) se divide el seniority.',
      invalidQuantityOfLevels: 'Este valor debe ser un número entero mayor o igual a 1',
    },
  },
};

export const ACTIVE_MAPS_RULES = {
  firstPage: 0,
  pageSize: 10,
  singleActiveMap: 1,
  maxActiveMaps: 2,
} as const;

export const IMMEDIATE_PUBLISH_COPIES = {
  checkboxLabel: 'Publicar inmediatamente',
  noActiveMapsMessage: 'La versión del mapa se publicará de inmediato y estará activa desde hoy.',
  oneActiveMapMessage:
    'La versión del mapa se publicará de inmediato. El mapa activo actual se inactivará el',
  twoActiveMapsMessage:
    'La versión del mapa se publicará de inmediato. Como ya existen 2 mapas activos, deberás seleccionar cuál inactivar.',
  inactivationDateQuestion:
    '¿Quieres programar la inactivación del mapa anterior para una fecha posterior?',
} as const;

export const MAP_SELECTION_COPIES = {
  inactivateModalHeader: 'Selecciona el mapa a inactivar',
  inactivateModalDescription:
    'Ya existen 2 mapas activos. Selecciona cuál deseas inactivar para publicar el nuevo mapa.',
  inactivateConfirmButton: 'Inactivar y publicar',
  valorationModalHeader: 'Selecciona el mapa de la valoración',
  valorationModalDescription:
    'La especialidad del pragmático tiene 2 mapas activos. Selecciona cuál quieres utilizar.',
  valorationConfirmButton: 'Continuar',
  cancelButton: 'Cancelar',
  radioGroupName: 'active-map-option',
} as const;
